'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = undefined;

var _systemComponents = require('system-components');

var _systemComponents2 = _interopRequireDefault(_systemComponents);

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = exports.Input = (0, _systemComponents2.default)({
  is: 'input',
  type: 'text',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  px: 1,
  py: 2,
  m: 0,
  width: 1,
  border: 0,
  borderColor: 'gray',
  boxShadow: 1,
  borderRadius: 2,
  color: 'inherit',
  bg: 'transparent'
}, function (props) {
  return {
    fontFamily: 'inherit',
    display: 'inline-block',
    verticalAlign: 'middle',
    border: 0,
    appearance: 'none',
    '&:focus': {
      outline: 'none',
      boxShadow: 'inset 0 0 0 1px ' + (0, _styledSystem.theme)('colors.blue')(props)
    },
    '&:disabled': {
      opacity: 1 / 4
    }
  };
});

Input.displayName = 'Input';

exports.default = Input;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Input.js
// module id = 820
// module chunks = 35783957827783